import styled from 'styled-components'

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const DialogWrapper = styled.div`
  width: 500px;
  max-width: 90vw;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
  transform: translateY(0);
  animation: slideIn 0.3s ease;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const DialogHeader = styled.div`
  background: linear-gradient(135deg, #5b83e1, #2e0fc9);
  padding: 24px;
  text-align: center;

  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: white;
  }
`

export const DialogContent = styled.div`
  background-color: white;
  padding: 24px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  textarea {
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #ddd;
    resize: none;
    font-size: 16px;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: #549ce9;
      box-shadow: 0 0 0 2px rgba(142, 84, 233, 0.2);
    }
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`

export const Button = styled.button`
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }
`

export const CancelButton = styled(Button)`
  background-color: transparent;
  color: #666;

  &:hover {
    background-color: #f0f0f0;
  }
`

export const RejectButton = styled(Button)`
  background-color: #f44336;
  color: white;

  &:hover {
    background-color: #d32f2f;
  }
`
